<template>
  <div>
    <dashboard-widget-header :title="config.name" />
    <div class="responsive-grid">
      <div class="responsive-grid__item" data-test="performance-questions-answered">
        <performance-overall-item
          icon-name="check"
          icon-background-color="#326FF0"
          title="Total Questions Answered"
          :value="String(questionsAnswered)"
        ></performance-overall-item>
      </div>
      <div class="full-width-spacer"></div>
      <div class="responsive-grid__item" data-test="performance-percent-correct">
        <performance-overall-item
          icon-name="pie-chart"
          icon-background-color="#00B46D"
          title="Percent Correct"
          :value="percentCorrectlyAnswered"
        ></performance-overall-item>
      </div>
      <div class="full-width-spacer"></div>
      <div class="responsive-grid__item" data-test="performance-average-time">
        <performance-overall-item
          icon-name="stop-watch"
          icon-background-color="#001C74"
          title="Avg Time per Question"
          :value="`${averageTimePerQuestion}`"
        ></performance-overall-item>
      </div>
      <div class="full-width-spacer"></div>
      <div class="responsive-grid__item" data-test="performance-longest-streak">
        <performance-overall-item
          icon-name="flame"
          icon-background-color="#E98726"
          title="Longest Streak"
          :value="`${longestStreak}`"
        ></performance-overall-item>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import PerformanceOverallItem from '@components/dashboard-widgets/performanceOverallItem';
import PerformanceMixin from '@/mixins/performance';
import { formatTotalSeconds } from '@/utils';

export default {
  components: { DashboardWidgetHeader, PerformanceOverallItem },
  mixins: [PerformanceMixin],
  computed: {
    averageTimePerQuestion() {
      if (this.questionsAnswered === 0) {
        return 'N/A';
      }
      let totalInSeconds = 0;
      this.flashcardStates.forEach(flashCardState => {
        totalInSeconds += flashCardState.timeInSeconds;
      });
      return this.formatTotalSeconds(totalInSeconds/this.questionsAnswered);
    },
    longestStreak() {
      const ordered = [...this.flashcardStates].sort((a, b) => {
        return a.mobileCreatedAt - b.mobileCreatedAt;
      });
      let longestStreak = 0;
      let currentStreak = 0;

      for (let i = 0; i < ordered.length; i++) {
        if (ordered[i].correct) {
          currentStreak++;
        } else {
          if (currentStreak > longestStreak) {
            longestStreak = currentStreak;
          }
          currentStreak = 0;
        }
      }

      if (currentStreak > longestStreak) {
        longestStreak = currentStreak;
      }
      return longestStreak;
    },
    percentCorrectlyAnswered() {
      const answered = this.questionsAnswered;
      const correctlyAnswered = this.flashcardStates.filter(cs => cs.correct).length;
      if (answered === 0) return 'N/A';
      return (Math.round((correctlyAnswered / answered) * 100) || 0) + '%';
    },
    questionsAnswered() {
      return this.flashcardStates.length;
    },
  },
  methods: {
    formatTotalSeconds,
  },
};
</script>

<style lang="scss" scoped>
.responsive-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 1rem;
  grid-auto-rows: minmax(rem-calc(85), auto);

  .full-width-spacer {
    display: none;
  }

  .responsive-grid__item {
    border: 1px solid #f1f1f1;
    border-radius: .5rem;
    padding: 1rem;
  }
}

@media (max-width: 600px) {
  .responsive-grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 1201px) {
  .responsive-grid {
    grid-template-columns: 1fr 2px 1fr 2px 1fr 2px 1fr;

    .full-width-spacer {
      display: unset;
      background: #f1f1f1;
    }

    .responsive-grid__item {
      border: none;
      padding: unset;
    }
  }

}
</style>
